import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import Select from 'react-select';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { TbMath } from 'react-icons/tb';
import MySelect from '../../components/MySelect';
import { GrWorkshop } from 'react-icons/gr';
import { IoIosSearch, IoMdCloseCircle } from 'react-icons/io';
import { MdAdsClick } from 'react-icons/md';
import TabHead from '../../components/TabHead';
import HourLoading from '../../components/HourLoading';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';

const AddPointage = ({ onClose }) => {
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();

    const [errors, setErrors] = useState([]);
    const { token, setToken } = useStateContext();
    const [cours, setCours] = useState([]);
    const [req, setReq] = useState({
        dateCours: ''
    })

    const onSubmit = (o) => {
        setErrors([]);

        axiosClient.post('/pointage', {
            'cours': o,
            'dateCours': req.dateCours,
        })
            .then((response) => {
                setLoading(false);
                setErrors([]);
                Swal.fire({
                    title: "Succes!",
                    icon: "success",
                    draggable: true
                });

            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                toast.error('Une erreur est survenue!', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }
                        }
                    }

                }
            })
    }

    const getPointages = () => {
        setCours([]);
        setErrors([]);
        setLoading(true);
        axiosClient.get('/cours?dateCours=' + req.dateCours)
            .then(response => {
                setCours(response.data.cours);
                setLoading(false);
                setErrors([]);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col max-h-screen  overflow-auto bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className='flex w-full justify-between'>
                            <div className="flex">
                                <Header icon={<GrWorkshop />} title="Pointer les cours" titleAr={"رفع حضور المدرسين"} />
                            </div>
                            <div className="text-red-500 text-lg">
                                <IoMdCloseCircle size={30} onClick={() => onClose()} />
                            </div>
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        <div className='flex-col  justify-evenly '>
                            <div className='mr-2 flex gap-2'>
                                <Input label="Date" labelAr={"التاريخ"} type="date" value={req.dateCours} onChange={ev => setReq({ ...req, dateCours: ev.target.value })} required="required" />
                                <div className="flex mt-8">
                                    <Button onClick={() => { getPointages() }} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                                </div>
                            </div>
                            <div className='mr-2'>
                                <div className='flex mt-3 overflow-auto'>
                                    <table className='table-auto' >
                                        <thead>
                                            <tr>
                                                <th><TabHead left="Actions" right={"إجراء"} /></th>
                                                <th><TabHead left="Jour" right="يوم" /></th>
                                                <th><TabHead left="Enseignant" right="المدرّس" /></th>
                                                <th><TabHead left="Classe" right="المستفيد" /></th>
                                                <th><TabHead left="Matière" right="المادّة" /></th>
                                            </tr>
                                        </thead>
                                        {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="6"><HourLoading /></td></tr></tbody> :
                                            <tbody>
                                                {cours && cours.map(o => (
                                                    <tr key={o.id}>
                                                        <td><ActionButton onClick={() => { onSubmit(o) }} color="bg-green-500" icon={<MdAdsClick />} textColor="text-white" title="Present" /></td>

                                                        <td>{o.jour.libelleFr}</td>
                                                        <td>{o.enseignant}</td>
                                                        <td>{o.classe}</td>
                                                        <td>{o.matiere}</td>
                                                    </tr>
                                                ))

                                                }
                                            </tbody>
                                        }

                                    </table>

                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </>

    )
}

export default AddPointage